import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ProveedorFormService {
  constructor(private fb: FormBuilder) {}

  getProveedorForm(): FormGroup {
    return this.fb.group({
      // info general
      nombreComercial: new FormControl(''),
      numRUC: new FormControl(''),
      nombreCompleto: new FormControl(''),
      dni: new FormControl(''),
      razonSocial: new FormControl(''),
      condicion: new FormControl(''),
      cuentaCorriente: new FormControl(''),
      tipoPersona: new FormControl('', {
        nonNullable: true,
        validators: Validators.required,
      }),
      estadoProveedor: new FormControl('', {
        nonNullable: true,
        validators: Validators.required,
      }),

      // direccion
      direccion: new FormControl('', {
        nonNullable: true,
        validators: Validators.required,
      }),
      urbanizacion: new FormControl(''),
      distrito: new FormControl(''),
      provincia: new FormControl(''),
      departamento: new FormControl(''),
      pais: new FormControl('', {
        nonNullable: true,
        validators: Validators.required,
      }),
      ubigeo: new FormControl(''),

      // observaciones
      titulo: new FormControl(''),
      observacion: new FormControl(''),

      // cuentas
      banco: new FormControl(''),
      moneda: new FormControl(''),
      numero: new FormControl(''),
      cci: new FormControl(''),
      observacionCuenta: new FormControl(''),
      favorito: new FormControl(''),

      // contacto
      nombre: new FormControl(''),
      cargo: new FormControl(''),
      correo: new FormControl(''),
      celular: new FormControl(''),
      telefono: new FormControl(''),
      telefonoAnexo: new FormControl(''),
    });
  }
}